import makeCategory from '@main/factories/pages/makeCategory';
import { useData } from 'vike-react/useData';

import type { Data } from './+data';

export function Page() {
	const { category, firstPage, intro } = useData<Data>();

	return makeCategory(category, firstPage, intro);
}
